export default (theme) => ({
    card: {
        // maxWidth: 345,
        margin : '15px'
    },
    media: {
        objectFit: 'cover',
        maxHeight: '200px',
    },
})